/* Quick add for product cards (duplicate theme only).
   - ADD TO CART on every card (type="button", no name="add", not a submit
     button, so cart-app submit/click handlers cannot double-add).
   - Single-variant: click adds the only variant directly via /cart/add.js.
   - Multi-variant: click opens an inline variant picker on the card; picking
     a variant adds THAT variant. Never navigates away, never silently adds
     a default variant.
   - After a successful add: header cart bubble refreshes, cart:updated /
     cart:change events fire, then the cart drawer opens.
   - If the AJAX add fails, falls back to a native POST /cart/add. */
(function () {
  'use strict';

  function drawerLooksOpen() {
    var candidates = document.querySelectorAll('.AOV-CartDrawer, #CartDrawer, .drawer--right, .drawer');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (!el.classList) continue;
      if (
        el.classList.contains('is-open') ||
        el.classList.contains('open') ||
        el.classList.contains('active') ||
        el.classList.contains('show') ||
        el.classList.contains('drawer--is-open') ||
        el.classList.contains('js-drawer-open')
      ) return true;
    }
    if (
      document.body.classList.contains('js-drawer-open') ||
      document.body.classList.contains('drawer--is-open') ||
      document.body.classList.contains('cart-drawer-open')
    ) return true;
    // AOV drawer slides in via transform: identity/none transform + visible
    // means it is on screen (closed state is translated off-screen).
    var aov = document.querySelector('.AOV-CartDrawer');
    if (aov) {
      var cs = window.getComputedStyle(aov);
      if (cs.display !== 'none' && cs.visibility !== 'hidden') {
        var t = cs.transform || cs.webkitTransform;
        if (!t || t === 'none' || t === 'matrix(1, 0, 0, 1, 0, 0)') return true;
      }
    }
    return false;
  }

  function openCartDrawer() {
    if (drawerLooksOpen()) return;
    var toggle = document.querySelector('.js-drawer-open-cart');
    if (toggle) toggle.click();
  }

  function refreshCartBubble() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bubbles = document.querySelectorAll('.cart-link__bubble');
        for (var i = 0; i < bubbles.length; i++) {
          bubbles[i].textContent = cart.item_count > 0 ? String(cart.item_count) : '';
          bubbles[i].classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
        }
      })
      .catch(function () {});
  }

  // Shared add: POST one unit of variantId, then refresh + open drawer.
  // onDone(true) on success; onDone(false) on failure (fallback POST runs).
  function addVariant(variantId, onDone) {
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed: ' + r.status);
        return r.json();
      })
      .then(function () {
        refreshCartBubble();
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
        window.setTimeout(openCartDrawer, 600);
        if (onDone) onDone(true);
      })
      .catch(function () {
        if (onDone) onDone(false);
        // Fallback: native POST to /cart/add (item still added, lands on cart page).
        var form = document.createElement('form');
        form.method = 'post';
        form.action = '/cart/add';
        form.style.display = 'none';
        var idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = 'id';
        idInput.value = variantId;
        var qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = 'quantity';
        qtyInput.value = '1';
        form.appendChild(idInput);
        form.appendChild(qtyInput);
        document.body.appendChild(form);
        form.submit();
      });
  }

  function closeAllPickers(except) {
    var pickers = document.querySelectorAll('[data-variant-picker]');
    for (var i = 0; i < pickers.length; i++) {
      if (pickers[i] !== except) pickers[i].hidden = true;
    }
  }

  document.addEventListener('click', function (e) {
    // (a) Variant option picked inside an inline picker: add THAT variant.
    var option = e.target && e.target.closest ? e.target.closest('[data-variant-option]') : null;
    if (option && !option.disabled) {
      var optVariantId = option.getAttribute('data-variant-id');
      if (optVariantId) {
        e.preventDefault();
        e.stopPropagation();
        var picker = option.closest('[data-variant-picker]');
        option.disabled = true;
        addVariant(optVariantId, function (ok) {
          option.disabled = false;
          if (ok && picker) picker.hidden = true;
        });
        return;
      }
    }
    // (b) ADD TO CART on a multi-variant card: toggle the inline picker.
    var pickerBtn = e.target && e.target.closest ? e.target.closest('[data-quick-add-picker-btn]') : null;
    if (pickerBtn && !pickerBtn.disabled) {
      e.preventDefault();
      e.stopPropagation();
      var wrap = pickerBtn.closest('[data-quick-add]');
      var pickerEl = wrap ? wrap.querySelector('[data-variant-picker]') : null;
      if (pickerEl) {
        var willOpen = pickerEl.hidden;
        closeAllPickers(pickerEl);
        pickerEl.hidden = !willOpen;
      }
      return;
    }
    // (c) ADD TO CART on a single-variant card: add directly.
    var btn = e.target && e.target.closest ? e.target.closest('[data-quick-add-btn]') : null;
    if (!btn || btn.disabled) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return; // SOLD OUT button has no variant id
    e.preventDefault();
    e.stopPropagation();
    btn.disabled = true;
    addVariant(variantId, function () { btn.disabled = false; });
  });
})();
